export const apiBase = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api';

export function authFetch(url, opts = {}) {
  let token = '';
  try { token = JSON.parse(localStorage.getItem('npd_user'))?.token || ''; } catch {}
  return fetch(url, {
    ...opts,
    headers: {
      ...(opts.headers || {}),
      ...(token ? { Authorization: 'Bearer ' + token } : {})
    }
  });
}
